/**
 * @module cookie
 * @description Cookie操作模块
 * @see {@link https://github.com/js-cookie/js-cookie#readme}
 * @author: Yawei Wang
 * @date: 2019-06-03 10:29:50
 */
import cookies from 'js-cookie';
/**
 * 设置cookie
 * @function
 * @param {String} key 键
 * @param {String|JSON} val 值
 * @param {Object} option 配置
 * @example Cookies.set('name', 'value');
 * @example Cookies.set('name', 'value', { expires: 7, path: '' });
 */

export const set = cookies.set;
/**
 * 获取cookie
 * @function
 * @param {String} key 键
 * @param {Object} option 配置
 * @example Cookies.get(); // => { name: 'value' }
 * @example Cookies.get('name'); // => 'value'
 * @example Cookies.get('foo', { domain: 'sub.example.com' }); // `domain` won't have any effect...!
 */

export const get = cookies.get;
/**
 * 移除cookie
 * @function
 * @param {String} key 键
 * @param {Object} option 配置
 * @example Cookies.remove('name');
 * @example Cookies.remove('name', { path: '', domain: '.yourdomain.com' });
 */

export const remove = cookies.remove;
/**
 * 直接暴露js-cookie
 */

export const cookie = cookies;